import { c as _c } from "react/compiler-runtime";
import { ReactNode, Ref } from 'react';
import Box from '@classify/react-core-components/Box';
import { styled } from '@classify/react-core-components/styles';
import Typography from '@classify/react-core-components/Typography';
const HeadingRoot = styled(Box)(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  paddingX: theme.spacing(3),
  paddingY: theme.spacing(2)
}));

// Reset Typography's default margins to allow flexbox alignment
const HeadingTitle = styled(Typography)({
  '&&': {
    margin: 0,
    padding: 0,
    marginBlock: 0,
    marginInline: 0
  }
});
type EmbeddedChapterHeadingProps = {
  icon: ReactNode;
  title: string;
  titleRef?: Ref<HTMLHeadingElement>;
};
const EmbeddedChapterHeading = t0 => {
  const $ = _c(6);
  const {
    icon,
    title,
    titleRef
  } = t0;
  let t1;
  if ($[0] !== title || $[1] !== titleRef) {
    t1 = <HeadingTitle variant="h5" component="h5" ref={titleRef}>{title}</HeadingTitle>;
    $[0] = title;
    $[1] = titleRef;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== icon || $[4] !== t1) {
    t2 = <HeadingRoot>{icon}{t1}</HeadingRoot>;
    $[3] = icon;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export default EmbeddedChapterHeading;